module.exports = __webpack_public_path__ + "img/new_index_customers3.4061ef8a.png";